import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../_services';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import { EditOrderComponent } from '../edit-order/edit-order.component';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {
  orderList:any;
  constructor(
    private _order : OrderService,
    private dialog : MatDialog,
  ) { }

  ngOnInit(): void {
    this.getOrderList();
  }

  getOrderList(){
    this._order.getOrderList().subscribe(res=>{
      this.orderList = res;
    },err=>{
      console.log('Error while fetching orders!',err);
    })
  }

  editOrder(id){
    this.dialog.open(EditOrderComponent, {
      width: 'auto',
      data:{
        id : id
      }
    });
  }

}
